/**
 * id をキーに重複要素を除去する。同一 id が複数ある場合は最後に出現したもの
 * （ページング連結では後から取得した、より新しいレコード）を残す。並び順は
 * 最初に出現した位置を保持する。
 * ページング結果を連結する際、境界で同一要素が重複することがあるため使用する。
 */
export const dedupeById = <T extends { id: string }>(items: T[]): T[] => {
  const map = new Map<string, T>();
  for (const item of items) {
    // 同一キーへの set は値のみ更新し、挿入位置（並び順）は最初のまま保持される
    map.set(item.id, item);
  }
  return Array.from(map.values());
};
